var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"component-tab-container"}},[_c('b-tabs',{staticClass:"container-tabs",attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"refs":"tab-centers","title":_vm.$t('centerPage.tabs.center'),"lazy":""}},[_c('div',{staticClass:"tab-content-custom"},[_vm._t("centers-content")],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }